document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-color-swatch]').forEach((swatch) => {
    swatch.addEventListener('click', () => {
      const card = swatch.closest('.card-wrapper');
      const image = card.querySelector('img');
      const variantImage = swatch.dataset.image;

      card.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      if (variantImage && image) {
        image.src = variantImage;
      }
    });
  });
});
